var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try {
            step(generator.next(value));
        }
        catch (e) {
            reject(e);
        } }
        function rejected(value) { try {
            step(generator["throw"](value));
        }
        catch (e) {
            reject(e);
        } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function () { if (t[0] & 1)
            throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function () { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f)
            throw new TypeError("Generator is already executing.");
        while (_)
            try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
                    return t;
                if (y = 0, t)
                    op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return { value: op[1], done: false };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [0];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2])
                            _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            }
            catch (e) {
                op = [6, e];
                y = 0;
            }
            finally {
                f = t = 0;
            }
        if (op[0] & 5)
            throw op[1];
        return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { DDQ } from '@api/utils';
import { getOOrder } from './get-o-order';
var TrackingCartAddUpdate = /*@__PURE__*/ (function () {
    function TrackingCartAddUpdate() {
        this.oOrders = [];
    }
    TrackingCartAddUpdate.prototype.addOOrder = function (tariff, product, offer, kiasCode, amount) {
        this.oOrders.push({
            tariff: tariff,
            product: product,
            offer: offer,
            kiasCode: kiasCode,
            amount: amount
        });
    };
    TrackingCartAddUpdate.prototype.getCartUpdate = function () {
        return __awaiter(this, void 0, void 0, function () {
            var oOrders, _i, _a, oOrderInformation, oOrder;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        oOrders = [];
                        _i = 0, _a = this.oOrders;
                        _b.label = 1;
                    case 1:
                        if (!(_i < _a.length))
                            return [3 /*break*/, 4];
                        oOrderInformation = _a[_i];
                        return [4 /*yield*/, getOOrder(oOrderInformation.tariff, oOrderInformation.product, oOrderInformation.offer, oOrderInformation.kiasCode, oOrderInformation.amount)];
                    case 2:
                        oOrder = _b.sent();
                        oOrders.push({
                            oOrder: oOrder
                        });
                        _b.label = 3;
                    case 3:
                        _i++;
                        return [3 /*break*/, 1];
                    case 4: return [2 /*return*/, {
                            addedProduct: oOrders
                        }];
                }
            });
        });
    };
    TrackingCartAddUpdate.prototype.track = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            return __awaiter(_this, void 0, void 0, function () {
                var _a, _b, _c, listener;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0:
                            _b = (_a = DDQ).push;
                            _c = ['update cart'];
                            return [4 /*yield*/, this.getCartUpdate()];
                        case 1:
                            _b.apply(_a, [_c.concat([_d.sent()])]);
                            listener = function () {
                                resolve();
                            };
                            DDQ.on('update cart', function () {
                                if (listener) {
                                    listener();
                                }
                                listener = null;
                            });
                            return [2 /*return*/];
                    }
                });
            });
        });
    };
    return TrackingCartAddUpdate;
}());
export { TrackingCartAddUpdate };
var TrackingCartRemoveUpdate = /*@__PURE__*/ (function () {
    function TrackingCartRemoveUpdate() {
        this.oOrders = [];
    }
    TrackingCartRemoveUpdate.prototype.addOOrder = function (tariff, product, offer, kiasCode, amount) {
        this.oOrders.push({
            tariff: tariff,
            product: product,
            offer: offer,
            kiasCode: kiasCode,
            amount: amount
        });
    };
    TrackingCartRemoveUpdate.prototype.getCartUpdate = function () {
        return __awaiter(this, void 0, void 0, function () {
            var oOrders, _i, _a, oOrderInformation, oOrder;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        oOrders = [];
                        _i = 0, _a = this.oOrders;
                        _b.label = 1;
                    case 1:
                        if (!(_i < _a.length))
                            return [3 /*break*/, 4];
                        oOrderInformation = _a[_i];
                        return [4 /*yield*/, getOOrder(oOrderInformation.tariff, oOrderInformation.product, oOrderInformation.offer, oOrderInformation.kiasCode, oOrderInformation.amount)];
                    case 2:
                        oOrder = _b.sent();
                        oOrders.push({
                            oOrder: oOrder
                        });
                        _b.label = 3;
                    case 3:
                        _i++;
                        return [3 /*break*/, 1];
                    case 4: return [2 /*return*/, {
                            removedProduct: oOrders
                        }];
                }
            });
        });
    };
    TrackingCartRemoveUpdate.prototype.track = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            return __awaiter(_this, void 0, void 0, function () {
                var _a, _b, _c, listener;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0:
                            _b = (_a = DDQ).push;
                            _c = ['update cart'];
                            return [4 /*yield*/, this.getCartUpdate()];
                        case 1:
                            _b.apply(_a, [_c.concat([_d.sent()])]);
                            listener = function () {
                                resolve();
                            };
                            DDQ.on('update cart', function () {
                                if (listener) {
                                    listener();
                                }
                                listener = null;
                            });
                            return [2 /*return*/];
                    }
                });
            });
        });
    };
    return TrackingCartRemoveUpdate;
}());
export { TrackingCartRemoveUpdate };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/api/services/tracking/tracking.cart-update.ts
// module id = null
// module chunks = 